{
  "generic": "Kutilmagan xato yuz berdi",
  "network": "Tarmoq xatosi. Aloqani tekshiring.",
  "notFound": "Sahifa topilmadi",
  "forbidden": "Ruxsat yo‘q",
  "tryAgain": "Qayta urinish"
}
